
import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';

export default function Copyright(props: any) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'版权所有 © '}
        <Link color="inherit" href="https://qm.qq.com/cgi-bin/qm/qr?k=U5T2BOXWzHzRMOk54yIBLPed8nzHsxbM&jump_from=webapi&authKey=1X2RgL8mooxTqO//oJGeX2ngfSqYCrx8kJ+CjEgFkML4dR7Hy01FoOzTq/P8uyBu" style={{textDecoration:"none"}}>
          竹米开放平台
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
}

